// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766
import styled from '@emotion/styled';
import { B400, N200 } from '@atlaskit/theme/colors';
// By default buttons will hide overflow and ellipsis content instead of wrapping.
// This basically turns the button back into inline content
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export var IconStyledButton = styled.span({
  // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
  '&&&': {
    textAlign: 'initial',
    display: 'inline',
    verticalAlign: 'baseline',
    borderRadius: "var(--ds-border-radius-100, 4px)",
    borderTopLeftRadius: '0px',
    borderBottomLeftRadius: '0px',
    padding: "var(--ds-space-025, 2px)".concat(" ", "var(--ds-space-075, 6px)"),
    backgroundClip: 'padding-box',
    boxDecorationBreak: 'clone'
  },
  // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
  '> span': {
    display: 'inline',
    overflow: 'initial',
    textOverflow: 'initial',
    whiteSpace: 'initial',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '> span': {
      overflow: 'initial',
      textOverflow: 'initial',
      whiteSpace: 'initial'
    }
  }
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export var NoLinkAppearance = styled.span({
  color: "var(--ds-text-subtlest, ".concat(N200, ")"),
  marginLeft: "var(--ds-space-050, 4px)"
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export var LinkAppearance = styled.a({
  color: "var(--ds-link, ".concat(B400, ")"),
  '&:hover': {
    textDecoration: 'none'
  }
});